module.exports = __webpack_public_path__ + "static/media/motorInspectPrimary.681ded9c.svg";